import {Moment} from 'moment-timezone'

import {getActiveAssets, getAssetsFromHistoryByDate, getOperationModesById} from '../selectors'

import {useAssetsHistoryQuery, type MomentRange} from './useAssetsHistoryQuery'

interface UseHistoryOperationModesByIdQueryParams {
  plantId: string
  timeFrame: MomentRange
  date?: Moment
}

export const useHistoryOperationModesByIdQuery = ({
  plantId,
  timeFrame,
  date
}: UseHistoryOperationModesByIdQueryParams) => {
  const [, endOfPlan] = timeFrame
  return useAssetsHistoryQuery({
    plantId,
    timeFrame,
    select: (assetsHistory) => {
      const assets = getAssetsFromHistoryByDate(assetsHistory, date ?? endOfPlan)
      const activeAssets = getActiveAssets(assets)
      return getOperationModesById(activeAssets)
    }
  })
}
